import firebase from '@firebase/app'
import '@firebase/auth'
import '@firebase/database'

const state = {
  loading: true,
  now: null,
  clock: null,
  courseToRegister: '',
  time: {
    day: 24 * 60 * 60 * 1000,
    hour: 60 * 60 * 1000,
    minute: 60 * 1000,
    second: 1000
  },
  reg: {
    digit: /^\d+$/,
    urlCleaner: /^[a-z\d\s]+$/i
  },
  appMsg: {
    show: false,
    type: '',
    msg: '',
    time: 0
  }
}

const getters = {
  loading (state) {
    return state.loading
  },
  courseToRegister (state) {
    return state.courseToRegister
  },
  time (state) {
    return state.time
  },
  reg (state) {
    return state.reg
  },
  appMsg (state) {
    return state.appMsg
  },
  now (state) {
    return state.now
  },
  clock (state) {
    return state.clock
  },
  rng () {
    return (min, max) => {
      return Math.round(Math.random() * (max - min)) + min
    }
  },
  capitalize () {
    return (str) => {
      const temp = str.split(' ')
      for (let i = 0; i < temp.length; i++) {
        if (temp[i] === 'rn' || temp[i] === 'pn' || temp[i] === 'nclex' || temp[i] === 'nclex-rn' || temp[i] === 'nclex-pn') temp[i] = temp[i].toUpperCase()
        else temp[i] = temp[i][0].toUpperCase() + temp[i].slice(1)
      }
      return temp.join(' ')
    }
  },
  formatUrl (state) {
    return (name) => {
      let url = ''
      for (let c of name) {
        if (state.reg.urlCleaner.test(c)) url += c
      }
      return url.split(' ').join('-').toLowerCase()
    }
  },
  arrayEquals () {
    return (arr1, arr2) => {
      if (!arr1 || !arr2) return false
      if (arr1.length !== arr2.length) return false
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false
      }
      return true
    }
  }
}

const mutations = {
  setLoading (state, payload) {
    state.loading = payload
  },
  setCourseToRegister (state, payload) {
    state.courseToRegister = payload
  },
  showAppMsg (state, payload) {
    state.appMsg = payload
  },
  resetAppMsg (state) {
    state.appMsg = {
      show: false,
      type: '',
      msg: '',
      time: 0
    }
  },
  setNow (state, payload) {
    state.now = payload
  },
  setClock (state, payload) {
    state.clock = payload
  }
}

const actions = {
  setCourseToRegister (store, payload) {
    store.commit('setCourseToRegister', payload)
  },
  getTime: (store) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('constants/currentTime')
    ref.set(firebase.database.ServerValue.TIMESTAMP).then(() => {
      ref.once('value', snapshot => {
        resolve(snapshot.val())
      })
    })
  }),
  startClock (store, payload) {
    store.dispatch('getTime').then(now => {
      store.commit('setNow', now)
      if (!store.getters.clock) {
        let clock = setInterval(() => {
          store.commit('setNow', store.getters.now + 1000)
        }, 1000)
        store.commit('setClock', clock)
      }
    })
  },
  stopClock (store) {
    clearInterval(store.getters.clock)
    store.commit('setClock', null)
    store.commit('setNow', null)
  },
  showAppMsg (store, payload) {
    store.commit('resetAppMsg')
    setTimeout(() => {
      const appMsg = {
        ...payload,
        show: true,
        time: payload.type === 'error' ? 60000 : 2500,
        msg: payload.type.toUpperCase() + ': ' + payload.msg
      }
      store.commit('showAppMsg', appMsg)
    }, 100)
  },
  resetAppMsg (store) {
    store.commit('resetAppMsg')
  },
  loadApp: (store) => new Promise((resolve, reject) => {
    firebase.auth().setPersistence('session').then(() => {
      firebase.auth().onAuthStateChanged(user => {
        store.dispatch('loader').then(() => {
          if (user) {
            firebase.database().ref('users/' + user.uid).once('value').then(snapshot => {
              store.dispatch('setUser', {uid: snapshot.key, ...snapshot.val()})
              store.commit('setLoading', false)
              resolve()
            })
          } else {
            store.dispatch('setUser', null)
            store.commit('setLoading', false)
            resolve()
          }
        })
      })
    })
  }),
  loader: (store) => new Promise((resolve, reject) => {
    const resourcesToLoad = []
    resourcesToLoad.push(store.dispatch('loadNotifications'))
    resourcesToLoad.push(store.dispatch('loadTags'))
    resourcesToLoad.push(store.dispatch('loadNclexAreas'))
    resourcesToLoad.push(store.dispatch('loadCourses'))
    resourcesToLoad.push(store.dispatch('loadContent'))
    resourcesToLoad.push(store.dispatch('loadProgress'))
    resourcesToLoad.push(store.dispatch('loadUsers'))
    resourcesToLoad.push(store.dispatch('loadPayments'))
    resourcesToLoad.push(store.dispatch('startClock'))

    Promise.all(resourcesToLoad).then(() => {
      resolve()
    })
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/utils.js